import {
  ROLE_JDTECH_ADMIN,
  ROLE_SALON_ADMIN,
  ROLE_SYSTEM_ADMIN,
} from "../../utils/constants";

/**
 * True for a salon admin who is neither a system admin nor a JDTech admin.
 * The API lets such a user assign only the locations they are assigned to.
 */
export function isLocationScoped(authUser) {
  const roles = Array.isArray(authUser?.userRoles) ? authUser.userRoles : [];
  return (
    roles.includes(ROLE_SALON_ADMIN) &&
    !roles.includes(ROLE_SYSTEM_ADMIN) &&
    !roles.includes(ROLE_JDTECH_ADMIN)
  );
}

/**
 * Locations the signed-in user may pick in the account form.
 *
 * A salon admin gets their own locations, plus the locations the edited user
 * already has, so an existing assignment stays visible. Everyone else gets
 * every location.
 */
export function getAssignableLocations(
  allLocations,
  authUser,
  existingLocationIds = []
) {
  const locations = Array.isArray(allLocations) ? allLocations : [];
  if (!isLocationScoped(authUser)) return locations;

  const own = Array.isArray(authUser?.assignedLocations)
    ? authUser.assignedLocations.map((loc) => loc?.location_id)
    : [];
  const allowed = new Set(
    [...own, authUser?.location_id, ...(existingLocationIds || [])]
      .filter((id) => id != null && id !== "")
      .map((id) => Number(id))
  );

  return locations.filter((loc) => allowed.has(Number(loc.location_id)));
}
